export default {
  FIXED: 'F',
  RANGE: 'R',
  POA: 'M'
}
